import { FC } from 'react';
import { styled } from 'styled-components';

interface IArrowButtonProps {
  className?: string;
  show?: boolean;
  onClick?: () => void;
}

const ArrowButtonWrap = styled.img<{ $show: boolean }>`
  width: 48rem;
  height: 48rem;
  background-color: #fff;
  border-radius: 50%;
  transform: rotate(90deg);
  display: ${(props) => (props.$show ? 'block' : 'none')};
`;

const ArrowButton: FC<IArrowButtonProps> = (props: IArrowButtonProps) => {
  return (
    <ArrowButtonWrap
      onClick={() => props.onClick?.()}
      className={props.className}
      $show={props.show ?? true}
      src={require('@img/common/icon-arrow.svg')}
    ></ArrowButtonWrap>
  );
};

export default ArrowButton;
